import { render, staticRenderFns } from "./MenuCommand.vue?vue&type=template&id=85cd5f2e"
import script from "./MenuCommand.vue?vue&type=script&lang=js"
export * from "./MenuCommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports